import { ymPushEvent } from './ym';
import { SERVICE_DISCONNECT_SUCCESS } from './constants';

/** Успешное отключение партнерской услуги */
const partnerServiceDisconnectedSuccessYM = (serviceName) => {
  ymPushEvent(
    SERVICE_DISCONNECT_SUCCESS,
    { ServiceDisconnect: { [serviceName]: document.location.href } },
  );
};

export { partnerServiceDisconnectedSuccessYM };
